import React from "react";
import {ReactComponent as Frame11 } from "./assets/CapitalAbout/frame-11.svg";
import {ReactComponent as Frame37 } from "./assets/CapitalAbout/frame-37.svg";
import {ReactComponent as Frame48095967 } from "./assets/CapitalAbout/frame-48095967.svg";
import {ReactComponent as Frame48095972 } from "./assets/CapitalAbout/frame-48095972.svg";
import {ReactComponent as Frame48095976 } from "./assets/CapitalAbout/frame-48095976.svg";
import {ReactComponent as Frame48095977 } from "./assets/CapitalAbout/frame-48095977.svg";
import {ReactComponent as Frame48095978 } from "./assets/CapitalAbout/frame-48095978.svg";
import {ReactComponent as Frame48095996 } from "./assets/CapitalAbout/frame-48095996.svg";
import {ReactComponent as Frame48096060 } from "./assets/CapitalAbout/frame-48096060.svg";
import {ReactComponent as IconComponentNode } from "./assets/CapitalAbout/frame-11.svg";
import {ReactComponent as Intersect } from "./assets/CapitalAbout/intersect.svg";
import {ReactComponent as Line13 } from "./assets/CapitalAbout/line-13.svg";
import {ReactComponent as Line24 } from "./assets/CapitalAbout/line-24.svg";
import {ReactComponent as Line29 } from "./assets/CapitalAbout/line-29.svg";
import {ReactComponent as Line7 } from "./assets/CapitalAbout/line-7.svg";
import {ReactComponent as Line92 } from "./assets/CapitalAbout/line-92.svg";
import {ReactComponent as NamecandidateNameFrame11Score101 } from "./assets/CapitalAbout/frame-11.svg";
import {ReactComponent as Vector } from "./assets/CapitalAbout/vector.svg";
import "./style.css";
import group41225 from "./assets/CapitalAbout/group-41225.png";
import aboutus256017061 from "./assets/CapitalAbout/about-us-2560x1706-1.png";
import group40897 from "./assets/CapitalAbout/group-40897.png";
import rectangle3 from "./assets/CapitalAbout/rectangle-3.png"; 
import rectangle32 from "./assets/CapitalAbout/rectangle-3-2.png";
import rectangle35 from  "./assets/CapitalAbout/rectangle-3-5.png";
import rectangle33 from "./assets/CapitalAbout/rectangle-3-3.png";
import rectangle36 from "./assets/CapitalAbout/rectangle-3-6.png";
import group41210  from "./assets/CapitalAbout/group-41210.png";
import rectangle34 from "./assets/CapitalAbout/rectangle-3-4.png";
import rectangle1024 from "./assets/CapitalAbout/rectangle-1024.png";
export const CapitalAbout = () => {
  return (
    <div className="capital-about">
      <div className="div">
        <div className="overlap">
          <div className="frame">
            <div className="optimisez-le">
              Optimisez <br />
              le rendement
            </div>
            <p className="de-vos-placements">
              <span className="text-wrapper">
                <br />
                de vos <br />
              </span>
              <span className="span">placements</span>
            </p>
          </div>
          <div className="frame-2">
            <Frame48096060 className="frame-48096060" />
            <div className="frame-3">
              <div className="frame-4">
                <div className="text-wrapper-2">À PROPOS</div>
                <div className="text-wrapper-2">RÉSEAUX SOCIAUX</div>
                <div className="text-wrapper-2">EN</div>
              </div>
              <img className="group" alt="Group" src={group41225} />
            </div>
          </div>
        </div>
        <div className="overlap-group">
          <div className="rectangle" />
          <div className="rectangle-2" />
          <div className="frame-wrapper">
            <div className="frame-5">
              <div className="div-wrapper">
                <div className="frame-6">
                  <Vector className="vector-instance" color="#FFFAE6" />
                  <div className="heading-example">NOTRE EXPERTISE</div>
                </div>
              </div>
              <p className="une-expertise">
                <span className="text-wrapper-3">Une </span>
                <span className="text-wrapper-4">expertise </span>
                <span className="text-wrapper-3">approfondie en investissement </span>
                <span className="text-wrapper-4">
                  immobilier.
                  <br />
                </span>
              </p>
            </div>
          </div>
          <img className="about-us" alt="About us" src={aboutus256017061} />
          <div className="group-2">
            <div className="frame-7">
              <div className="frame-8">
                <div className="frame-9">
                  <Line13 className="line" />
                  <div className="heading-example-2">Performante</div>
                </div>
                <Frame48095967 className="icon-instance-node" />
                <div className="group-3">
                  <p className="p">
                    Nous valorisons la possibilité d&#39;investir, de contribuer à notre communauté et de nous
                    concentrer sur ce qui compte vraiment pour nous. Cela s&#39;atteint grâce à des stratégies orientés
                    vers la performance.
                  </p>
                  <Line13 className="line-13" />
                </div>
              </div>
            </div>
          </div>
          <div className="group-4">
            <div className="frame-7">
              <div className="frame-8">
                <div className="frame-9">
                  <Line13 className="line" />
                  <div className="heading-example-2">Empathique</div>
                </div>
                <div className="intersect-wrapper">
                  <Intersect className="intersect-instance" />
                </div>
                <div className="group-3">
                  <p className="p">
                    Nous partageons les mêmes rêves que nos clients. Nous comprenons leur réalité et appliquons les
                    mêmes outils et principes que nous proposons, assurant ainsi une expérience enrichissante.
                  </p>
                  <Line13 className="line-13" />
                </div>
              </div>
            </div>
          </div>
          <div className="group-5">
            <div className="frame-7">
              <div className="frame-8">
                <div className="frame-9">
                  <Line13 className="line" />
                  <div className="heading-example-2">Experte</div>
                </div>
                <img className="img" alt="Group" src={group40897} />
                <div className="group-6">
                  <p className="heading-example-3">
                    Notre expertise se forge sur le terrain, allant au-delà des formations. Les projets complexes ont
                    affiné notre approche. Notre équipe, composée d&#39;actuaires et <br />
                    de passionnés, offre un accompagnement <br />
                    direct et transparent.
                  </p>
                  <Line13 className="line-13-instance" />
                </div>
              </div>
            </div>
          </div>
          <div className="frame-10">
            <Line7 className="line-7" />
            <div className="frame-11">
              <div className="frame-12">
                <div className="text-wrapper-5">01</div>
                <div className="text-wrapper-6">Ingénierie financière</div>
              </div>
              <Frame48095972 className="icon-instance-node" />
            </div>
            <Line7 className="line-6" />
            <div className="frame-11">
              <div className="frame-12">
                <div className="text-wrapper-5">02</div>
                <div className="text-wrapper-7">Ingénierie financière</div>
              </div>
              <Frame48095972 className="icon-instance-node" />
            </div>
            <Line7 className="line-6" />
            <div className="frame-11">
              <div className="frame-12">
                <div className="text-wrapper-5">03</div>
                <div className="text-wrapper-7">Ingénierie financière</div>
              </div>
              <Frame48095972 className="icon-instance-node" />
            </div>
            <Line7 className="line-6" />
            <div className="frame-11">
              <div className="frame-12">
                <div className="text-wrapper-5">04</div>
                <div className="text-wrapper-7">Ingénierie financière</div>
              </div>
              <Frame48095972 className="icon-instance-node" />
            </div>
            <Line7 className="line-6" />
            <div className="frame-11">
              <div className="frame-12">
                <div className="text-wrapper-5">05</div>
                <div className="text-wrapper-7">Ingénierie financière</div>
              </div>
              <Frame48095972 className="icon-instance-node" />
            </div>
            <Line7 className="line-6" />
            <div className="frame-11">
              <div className="frame-12">
                <div className="text-wrapper-5">06</div>
                <div className="text-wrapper-7">Ingénierie financière</div>
              </div>
              <Frame48095972 className="icon-instance-node" />
            </div>
            <Line7 className="line-6" />
            <div className="frame-11">
              <div className="frame-12">
                <div className="text-wrapper-5">07</div>
                <div className="text-wrapper-7">Ingénierie financière</div>
              </div>
              <Frame48095972 className="icon-instance-node" />
            </div>
            <Line7 className="line-6" />
          </div>
          <div className="rectangle-3" />
          <div className="rectangle-4" />
          <div className="group-7">
            <div className="frame-13">
              <div className="frame-5">
                <div className="group-8">
                  <div className="frame-6">
                    <Vector className="vector-instance" color="#FFFAE6" />
                    <div className="heading-example">NOTRE ÉQUIPE PASSIONNÉE</div>
                  </div>
                </div>
                <p className="cr-ateurs-de-valeur">
                  <span className="text-wrapper-4">Créateurs </span>
                  <span className="text-wrapper-8"> de Valeur </span>
                  <span className="text-wrapper-4">Immobilière</span>
                </p>
              </div>
            </div>
            <div className="frame-14">
              <div className="frame-15">
                <img className="rectangle-5" alt="Rectangle" src={rectangle32} />
                <div className="group-9">
                  <Line92 className="line-92" />
                  <div className="frame-16">
                    <div className="frame-17">
                      <div className="frame-18">
                        <div className="text-wrapper-9">Philippe Foisy</div>
                      </div>
                      <div className="group-10">
                        <div className="frame-6">
                          <div className="heading-example">PRÉSIDENT ET FONDATEUR</div>
                        </div>
                      </div>
                    </div>
                    <Frame37 className="frame-37" />
                  </div>
                </div>
              </div>
              <div className="frame-15">
                <img className="rectangle-5" alt="Rectangle" src={rectangle35} />
                <div className="group-9">
                  <Line92 className="line-92" />
                  <div className="frame-16">
                    <div className="frame-17">
                      <div className="frame-18">
                        <div className="text-wrapper-9">Philippe Foisy</div>
                      </div>
                      <div className="group-10">
                        <div className="frame-6">
                          <div className="heading-example">PRÉSIDENT ET FONDATEUR</div>
                        </div>
                      </div>
                    </div>
                    <Frame37 className="frame-37" />
                  </div>
                </div>
              </div>
              <div className="frame-15">
                <img className="rectangle-5" alt="Rectangle" src={rectangle35} />
                <div className="group-9">
                  <Line92 className="line-92" />
                  <div className="frame-16">
                    <div className="frame-17">
                      <div className="frame-18">
                        <div className="text-wrapper-9">Philippe Foisy</div>
                      </div>
                      <div className="group-10">
                        <div className="frame-6">
                          <div className="heading-example">PRÉSIDENT ET FONDATEUR</div>
                        </div>
                      </div>
                    </div>
                    <Frame37 className="frame-37" />
                  </div>
                </div>
              </div>
              <div className="frame-15">
                <img className="rectangle-5" alt="Rectangle" src={rectangle33} />
                <div className="group-9">
                  <Line92 className="line-92" />
                  <div className="frame-16">
                    <div className="frame-17">
                      <div className="frame-18">
                        <div className="text-wrapper-9">Philippe Foisy</div>
                      </div>
                      <div className="group-10">
                        <div className="frame-6">
                          <div className="heading-example">PRÉSIDENT ET FONDATEUR</div>
                        </div>
                      </div>
                    </div>
                    <Frame37 className="frame-37" />
                  </div>
                </div>
              </div>
              <div className="frame-15">
                <img className="rectangle-5" alt="Rectangle" src={rectangle33} />
                <div className="group-9">
                  <Line92 className="line-92" />
                  <div className="frame-16">
                    <div className="frame-17">
                      <div className="frame-18">
                        <div className="text-wrapper-9">Philippe Foisy</div>
                      </div>
                      <div className="group-10">
                        <div className="frame-6">
                          <div className="heading-example">PRÉSIDENT ET FONDATEUR</div>
                        </div>
                      </div>
                    </div>
                    <Frame37 className="frame-37" />
                  </div>
                </div>
              </div>
              <div className="frame-15">
                <img className="rectangle-5" alt="Rectangle" src={rectangle36} />
                <div className="group-9">
                  <Line92 className="line-92" />
                  <div className="frame-16">
                    <div className="frame-17">
                      <div className="frame-18">
                        <div className="text-wrapper-9">Philippe Foisy</div>
                      </div>
                      <div className="group-10">
                        <div className="frame-6">
                          <div className="heading-example">PRÉSIDENT ET FONDATEUR</div>
                        </div>
                      </div>
                    </div>
                    <Frame37 className="frame-37" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="group-wrapper">
            <div className="group-11">
              <Line24 className="line-24" />
              <div className="frame-19">
                <div className="frame-20">
                  <p className="text-wrapper-10">COPYRIGHT © 2024 BEATIMO | TOUT DROITS RÉSERVÉS</p>
                  <div className="text-wrapper-10">PRÉFÉRENCE DES TÉMOINS</div>
                  <div className="text-wrapper-10">POLITIQUES ET CONFIDENTIALITÉ</div>
                </div>
                <p className="site-par-les-mauvais">SITE PAR LES MAUVAIS GARÇONS</p>
              </div>
              <img className="group-12" alt="Group" src={group41210} />
              <div className="group-13">
                <Line29 className="line-29" />
                <Line29 className="line-25" />
                <Line29 className="line-26" />
                <div className="overlap-group-2">
                  <div className="text-wrapper-11">01</div>
                  <div className="text-wrapper-12">Facebook</div>
                </div>
                <div className="overlap-2">
                  <div className="text-wrapper-13">03</div>
                  <div className="text-wrapper-14">LinkedIn</div>
                </div>
                <Line29 className="line-30" />
                <div className="overlap-3">
                  <div className="text-wrapper-15">02</div>
                  <div className="text-wrapper-14">Youtube</div>
                </div>
                <div className="overlap-4">
                  <div className="text-wrapper-15">04</div>
                  <div className="text-wrapper-14">Tiktok</div>
                </div>
                <div className="group-14">
                  <div className="frame-6">
                    <Vector className="vector-instance" color="#EEFFF6" />
                    <div className="heading-example-4">NOS RÉSEAUX SOCIAUX</div>
                  </div>
                </div>
                <Frame48095976 className="frame-48095976" />
                <Frame48095977 className="frame-48095977" />
                <Frame48095978 className="frame-48095978" />
                <IconComponentNode className="frame-11-instance" />
              </div>
            </div>
          </div>
          <div className="rectangle-6" />
          <div className="frame-21">
            <div className="frame-22">
              <div className="frame-23">
                <Vector className="vector-instance" color="#FFFAE6" />
                <div className="heading-example">CARRIÈRE</div>
              </div>
              <p className="heading">
                <span className="text-wrapper-16">Nous </span>
                <span className="text-wrapper-17">sommes</span>
                <span className="text-wrapper-16"> toujours à  la recherche de </span>
                <span className="text-wrapper-17">talents</span>
                <span className="text-wrapper-16">.  Êtes-vous </span>
                <span className="text-wrapper-17">partant</span>
                <span className="text-wrapper-16"> ?</span>
              </p>
            </div>
            <div className="frame-24">
              <div className="frame-25">
                <div className="frame-26">
                  <div className="frame-27">
                    <div className="text-wrapper-18">DÉCOUVRIR NOS POSTES</div>
                  </div>
                </div>
                <NamecandidateNameFrame11Score101 className="frame-28" />
              </div>
            </div>
          </div>
        </div>
        <div className="overlap-wrapper">
          <div className="overlap-5">
            <div className="frame-29">
              <div className="overlap-group-wrapper">
                <div className="overlap-group-3">
                  <p className="heading-example-5">
                    Beatimo est une entreprise renommée dans le domaine de l&#39;analyse et de l&#39;optimisation des
                    performances commerciales. Son expertise réside dans sa capacité à utiliser des données avancées et
                    des techniques d&#39;analyse pour aider les entreprises à améliorer leur efficacité opérationnelle,
                    leur rentabilité et leur croissance.
                  </p>
                  <div className="group-15" />
                </div>
              </div>
              <p className="heading-example-6">
                Grâce à une équipe de professionnels hautement qualifiés et à des technologies de pointe, Beatimo
                fournit des solutions personnalisées qui permettent aux entreprises de prendre des décisions éclairées
                et de maximiser leur potentiel.
              </p>
              <div className="frame-24">
                <div className="frame-25">
                  <div className="frame-30">
                    <div className="frame-27">
                      <div className="text-wrapper-18">DÉCOUVRIR NOTRE ÉQUIPE</div>
                    </div>
                  </div>
                  <Frame11 className="frame-28" />
                </div>
              </div>
            </div>
            <div className="frame-31">
              <div className="mission-vision-wrapper">
                <p className="mission-vision">
                  <span className="text-wrapper-3">
                    Mission <br />
                  </span>
                  <span className="text-wrapper-4">&amp; Vision</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <img className="rectangle-7" alt="Rectangle" src={rectangle3} />
        <img className="rectangle-8" alt="Rectangle" src={rectangle1024} />
        <div className="overlap-6">
          <Frame48095996 className="frame-48095996" />
          <Frame48095996 className="frame-48095996" />
          <Frame48095996 className="frame-48095996" />
          <Frame48095996 className="frame-48095996" />
          <Frame48095996 className="frame-48095996" />
          <Frame48095996 className="frame-48095996" />
        </div>
      </div>
    </div>
  );
};
export default CapitalAbout;